// extracted by mini-css-extract-plugin
export default {"equipmentAddFieldModalTitle":"style_equipmentAddFieldModalTitle__7ZLKQ","actionBtn":"style_actionBtn__yPfej"};